<template>
  <div>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card" style="height: 655px">
            <!-- Card header -->
            <div class="card-header py-3">
              <div class="d-lg-flex align-items-center row">
                <div class="col-4">
                  <input
                    v-model="table.search"
                    class="form-control rounded-pill text-center"
                    type="text"
                    placeholder="Search Work Center"
                    @keyup="filter"
                  />
                </div>
              </div>
            </div>
            <!-- Card Body -->
            <div class="table-responsive" style="height: 500px">
              <table v-if="!table.onLoad" class="table">
                <thead class="table-primary">
                  <tr>
                    <th class="text-uppercase text-dark text-xxs font-weight-bolder">Main Work Center</th>
                    <th class="text-uppercase text-dark text-xxs font-weight-bolder">Description</th>
                    <th class="text-uppercase text-dark text-xxs font-weight-bolder">Created By</th>
                    <th class="text-uppercase text-dark text-xxs font-weight-bolder">Created At</th>
                  </tr>
                </thead>
                <tbody v-if="table.data.length > 0">
                  <tr v-for="workCenter in table.data" :key="workCenter.id">
                    <td class="text-sm py-3 px-4 value-table-wrapped">{{ workCenter.main_work_center }}</td>
                    <td class="text-sm py-3 px-4 value-table-wrapped">{{ workCenter.main_work_center_desc }}</td>
                    <td class="text-sm py-3 px-4 value-table-wrapped">{{ workCenter.created_by }}</td>
                    <td class="text-sm py-3 px-4 value-table-wrapped">{{ formatDate(workCenter.created_at) }}</td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr class="text-center">
                    <td colspan="3">No Data</td>
                  </tr>
                </tbody>
              </table>

              <SkeletonLoading
                v-else
                class="px-4 pt-5"
                :shapes="[ 
                  { type: 'line', width: '100%', height: '20px' },
                  { type: 'line', width: '80%', height: '20px' },
                  { type: 'line', width: '60%', height: '20px' },
                ]"
              />
            </div>
            <div class="card-footer pb-0">
              <span class="float-start">
                <BasePagination
                  v-model="table.page.current_pages"
                  :page-count="table.page.total_pages"
                  size="sm"
                  @click="changePage()"
                />
              </span>
              <span class="float-end">
                {{
                  (table.page.current_pages - 1) * table.page.per_pages +
                  table.data.length
                }}
                of {{ table.total }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BasePagination from "@/components/BasePagination.vue";
import SkeletonLoading from "@/components/SkeletonLoading.vue";
import moment from "moment";
import api from "@/helpers/api";
import workCenterService from "@/services/generalMasterData/workCenterService";

export default {
  components: {
    BasePagination,
    SkeletonLoading,
  },
  data() {
    return {
      loadTimeout: null,
      table: {
        onLoad: true,
        search: this.$route.query.search ? this.$route.query.search : '',
        total: 0,
        data: [],
        page: {
          current_pages: 1,
          per_pages: 100,
        },
      },
    };
  },
  watch: {
    "table.page.current_pages": {
      handler() {
        this.get();
      },
    },
  },
  mounted() {
    this.get();
  },
  methods: {
    async get() {
      this.table.onLoad = true;

      try {
        const response = await api(
          this,
          workCenterService.list(this.table.page.current_pages, {search: this.table.search}), false);

        this.table.data = response.data.data;
        this.table.total = response.data.total_items;
        this.table.page = response.data;
      } catch (error) {
        this.table.data = [];
        this.table.total = 0;
      } finally {
        this.table.onLoad = false;
      }
    },
    filter() {
      if(this.table.search != this.$route.query.search){
          clearTimeout(this.table.loadTimeout);
          this.table.loadTimeout = setTimeout(() => {
              if(this.table.search == ''){
                  this.$router.push({ query:null})
              } else {
                  this.$router.push({ query:{search: this.table.search} })
              }
              
              this.get()
          }, 500);
      }
    },
    changePage() {
      this.get();
    },
    formatDate(date) {
      return moment(date).format("DD MMMM YYYY, HH:mm");
    },
  },
};
</script>

<style scoped>
/* Tambahkan styling sesuai kebutuhan */
</style>
